import React from 'react'
import { Text } from '../../../../styles/reactnative'
import TranslateText from '../../TranslateText'
import OVManage from '../OVManage'

export const column_ovs = (
	mutate,
	usermodal,
	token,
	fold,
	edit,
	setEdit,
	shareMutate
) => {
	return [
		{
			title: '구분코드',
			dataIndex: 'code',
			align: 'center',
			key: 'code',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '이름',
			dataIndex: 'codename',
			align: 'center',
			key: 'codename',
			render: (text, record) => {
				return <TranslateText text={text} />
			},
		},
		{
			title: '거래소',
			dataIndex: 'exchange_code',
			align: 'center',
			key: 'exchange_code',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '종목코드',
			dataIndex: 'symbol',
			align: 'center',
			key: 'symbol',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '종목명',
			dataIndex: 'name',
			align: 'center',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '호가단위',
			dataIndex: 'unit',
			key: 'unit',
			align: 'center',
			width: 100,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '통화단위',
			dataIndex: 'currency',
			key: 'currency',
			align: 'center',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '계약당금액',
			dataIndex: 'contract_amount',
			key: 'contract_amount',
			align: 'center',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '월물',
			dataIndex: 'yearmonth',
			key: 'yearmonth',
			align: 'center',
			render: (text, record) => {
				return (
					<Text>
						{record?.year}-{record?.month}
					</Text>
				)
			},
		},
		{
			title: '등록일',
			dataIndex: 'appldate',
			key: 'appldate',
			align: 'center',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '관리',
			dataIndex: 'manage',
			key: 'manage',
			align: 'center',
			render: (text, record) => {
				return (
					<OVManage
						data={record}
						mutate={p => {
							mutate(p)
							shareMutate(p)
						}}
					/>
				)
			},
		},
	]
}
